import Vue from 'vue'
import Vuex from 'vuex'

import api from "./modules/api";
import actions from "./modules/actions";
import chat from "./modules/chat";
import user from "./modules/user";
import modal_route from "./modules/modal_route";
import modal from "./modules/modal";
import notification from "./modules/notification";
import contador from "./modules/contador";
import datatable from "./modules/datatable";
import tarefas from "./modules/tarefas";
import current_route from "./modules/current_route";
import loading from "./modules/loading";
import ligacao from "./modules/ligacao";
import historico from "./modules/historico";
Vue.use(Vuex)
Vue.config.devtools = process.env.NODE_ENV === 'development'

//Vue.config.devtools = process.env.NODE_ENV === 'development'

const store = new Vuex.Store({
    modules: {
        api,
        actions,
        chat,
        current_route,
        user,
        loading,
        modal_route,
        modal,
        notification,
        contador,
        datatable,
        tarefas,
        ligacao,
        historico
    }
})

export default store;
